import { Modal } from 'antd';
import { useEffect, useRef } from 'react';

const PrintModal = ({ data, onClose }) => {
  const iframe = useRef();
  useEffect(() => {
    if (iframe.current) {
      iframe.current.contentWindow.print();
    }
  }, [iframe]);

  return (
    <Modal
      visible
      title="Barkod Yazdır"
      maskClosable={false}
      centered
      width={950}
      onCancel={onClose}
      footer={false}
    >
      <iframe
        src={data}
        title="Barkod"
        ref={iframe}
        style={{ width: '100%', height: 600, border: 'none' }}
      />
    </Modal>
  );
};

export default PrintModal;
